export const locales = [
  "en",
  "he",
  "ar",
  "fr",
  "es",
  "de",
  "zh",
  "ja",
  "ko",
  "ru",
  "pt",
  "it",
  "tr",
  "nl",
  "pl",
] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

export const localeNames: Record<Locale, string> = {
  en: "English",
  he: "עברית",
  ar: "العربية",
  fr: "Français",
  es: "Español",
  de: "Deutsch",
  zh: "中文",
  ja: "日本語",
  ko: "한국어",
  ru: "Русский",
  pt: "Português",
  it: "Italiano",
  tr: "Türkçe",
  nl: "Nederlands",
  pl: "Polski",
};

export const rtlLocales: Locale[] = ["he", "ar"];

export function isRtlLocale(locale: string): boolean {
  return rtlLocales.includes(locale as Locale);
}

// Map country codes to preferred locale
export const countryToLocale: Record<string, Locale> = {
  US: "en",
  GB: "en",
  CA: "en",
  AU: "en",
  IL: "he",
  SA: "ar",
  AE: "ar",
  EG: "ar",
  FR: "fr",
  BE: "fr",
  ES: "es",
  MX: "es",
  AR: "es",
  DE: "de",
  AT: "de",
  CH: "de",
  CN: "zh",
  TW: "zh",
  HK: "zh",
  JP: "ja",
  KR: "ko",
  RU: "ru",
  BR: "pt",
  PT: "pt",
  IT: "it",
  TR: "tr",
  NL: "nl",
  PL: "pl",
};

// Map country codes to preferred currency
export const countryToCurrency: Record<string, string> = {
  US: "USD",
  GB: "GBP",
  CA: "CAD",
  AU: "AUD",
  IL: "ILS",
  SA: "SAR",
  AE: "AED",
  EG: "EGP",
  FR: "EUR",
  DE: "EUR",
  ES: "EUR",
  IT: "EUR",
  NL: "EUR",
  AT: "EUR",
  BE: "EUR",
  PT: "EUR",
  CH: "CHF",
  CN: "CNY",
  TW: "TWD",
  HK: "HKD",
  JP: "JPY",
  KR: "KRW",
  RU: "RUB",
  BR: "BRL",
  MX: "MXN",
  AR: "ARS",
  TR: "TRY",
  PL: "PLN",
};
